import { render, staticRenderFns } from "./FormItemConfig.vue?vue&type=template&id=ba159f7a&scoped=true&"
import script from "./FormItemConfig.vue?vue&type=script&lang=js&"
export * from "./FormItemConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormItemConfig.vue?vue&type=style&index=0&id=ba159f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba159f7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba159f7a')) {
      api.createRecord('ba159f7a', component.options)
    } else {
      api.reload('ba159f7a', component.options)
    }
    module.hot.accept("./FormItemConfig.vue?vue&type=template&id=ba159f7a&scoped=true&", function () {
      api.rerender('ba159f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/FormItemConfig.vue"
export default component.exports